import React from "react";
import { observer } from "mobx-react-lite";

import pl from "shared/messages/pl";
import { BasicTable, RegularText, TextTableHeader } from "shared/components";
import { Contract } from "view360Card/models";
import { MobileViewCard } from "../mobileViewCard/MobileViewCard";
import { constants } from "shared/constants";
import { MobileViewCardDetailsItem } from "../mobileViewCardDetailsItem/MobileViewCardDetailsItem";
import styles from "./contractsTable.module.scss";
import { formatDate } from "utils/formattingUtils";

export interface ContractsTableProps {
    contracts: Contract[];
}

export const ContractsTable: React.FC<ContractsTableProps> = observer((props) => {
    const headerItems = [
        {
            content: <TextTableHeader content={pl.view360Card.contractsTable.fromTo} />,
            key: "period",
            className: styles.columnNumberTenant,
        },
        {
            content: <TextTableHeader content={pl.view360Card.contractsTable.type} />,
            key: "type",
        },
        {
            content: <TextTableHeader content={pl.view360Card.contractsTable.status} />,
            key: "status",
        },
        {
            content: <TextTableHeader content={pl.view360Card.contractsTable.period} />,
            key: "contractType",
        },
    ];

    const getRows = () => {
        return props.contracts.map((contract) => {
            return {
                key: contract.id,
                items: [
                    {
                        className: styles.columnNumberTenant,
                        key: `${contract.id}-period`,
                        content: <RegularText content={getMobileHeader(contract)} />,
                    },
                    {
                        key: `${contract.id}-type`,
                        content: <RegularText content={contract.type?.description ?? constants.noValue} />,
                    },
                    {
                        key: `${contract.id}-status`,
                        content: <RegularText content={contract.status?.description ?? constants.noValue} />,
                    },
                    {
                        key: `${contract.id}-contractType`,
                        content: <RegularText content={contract.period?.description ?? constants.noValue} />,
                    },
                ],
            };
        });
    };

    const getMobileHeader = (contract: Contract) => {
        return `${contract.startDate ? formatDate(contract.startDate) : constants.noValue} - ${
            contract.endDate ? formatDate(contract.endDate) : constants.noValue
        } `;
    };

    const getMobilViewDetailItem = (contract: Contract) => {
        return [
            <MobileViewCardDetailsItem
                label={pl.view360Card.contractsTable.type}
                content={contract.type?.description ?? constants.noValue}
            />,
            <MobileViewCardDetailsItem
                label={`${pl.view360Card.contractsTable.status} ${constants.inlineSeparator} ${pl.view360Card.contractsTable.period}`}
                content={`${contract.status?.description ?? constants.noValue} ${constants.inlineSeparator} ${contract.period?.description ?? constants.noValue}`}
            />,
        ];
    };

    const getMobileViewRows = () => {
        if (!props.contracts) {
            return null;
        }

        return props.contracts.map((contracts) => {
            return (
                <MobileViewCard key={contracts.id} header={getMobileHeader(contracts)} detailsItems={getMobilViewDetailItem(contracts)} />
            );
        });
    };

    return (
        <BasicTable
            rows={getRows()}
            headerItems={headerItems}
            mobileViewRows={getMobileViewRows()}
            maxDefaultSize={3}
        />
    );
});
